$(function () {
  $('img.enable-zoom').ezPlus({
    cursor: 'crosshair',
    zoomType: "lens",
    lensSize: 300,
    lensShape: "round",
  });

});
